import { Stack, HStack, Box, Text } from '@chakra-ui/core';
import React, { useCallback } from 'react';
import colors from '../../../../styles/colors';
import { ReviewDocumentUpload } from './ReviewDocumentUpload';
import { ReviewMCQ } from './ReviewMCQ';
import { FormDataItem, QuestionOnReviewT, QuestionType } from './ReviewQuestion.types';
import { AcceptRejectActions } from './ReviewQuestionsActions';
import { ReviewVideoQuestion } from './ReviewVideoQuestion';
import { ReviewYesNo } from './ReviewYesNo';

export const QuestionItem = React.memo<{
  question: QuestionOnReviewT;
  formData: FormDataItem[];
  onAnswerChange: (questionId: string, questionType: string, isAnswerAccepted: boolean) => void;
}>(function QuestionItem({ question, formData, onAnswerChange }) {
  const currentQuestion = formData.find((item) => item.questionId === question.id);
  const isAnswerAccepted = currentQuestion?.isAnswerAccepted ?? question.isAnswerAccepted;
  const hasBeenReviewed = Boolean(currentQuestion) || Boolean(question.reviewedBy);

  const handleChange = useCallback(
    (isAccepted: boolean) => {
      onAnswerChange(question.id, question.type, isAccepted);
    },
    [question.id, question.type, onAnswerChange],
  );

  return (
    <Stack spacing={2}>
      <HStack>
        <Text flexGrow={1} fontSize="sm" fontWeight="bold" color={colors.text.dark}>
          {question.text}
        </Text>
        <AcceptRejectActions
          questionId={question.id}
          isAnswerAccepted={isAnswerAccepted}
          hasBeenReviewed={hasBeenReviewed}
          onChange={handleChange}
        />
      </HStack>

      <Box>
        <ReviewYesNo question={question} />

        {question.type === QuestionType.FREE_FORM && question.answer && (
          <Text fontSize="sm" color={colors.text.light}>
            {question.answer as string}
          </Text>
        )}

        <ReviewMCQ question={question} />

        <ReviewVideoQuestion question={question} />

        <ReviewDocumentUpload question={question} />
      </Box>
    </Stack>
  );
});
